module.exports = __webpack_public_path__ + "static/media/41.b4174559.svg";